import "./App.css";
import "./css/ai-assistant.css";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext.jsx";
import { AiAssistantProvider } from "./context/AiAssistantContext.jsx";
import AiAssistantPanel from "./component/AiAssistant/AiAssistantPanel.jsx";
import NewsList from "./modules/News/NewsList";
import Layout from "./layout/Layout";
import MatchingNews from "./modules/News/MatchingNews";
import NewsView from "./modules/News/NewsView";
import ChartsModule from "./modules/Charts";
import ModelsModule from "./modules/Models";
import Login from "./modules/auth/Login";
import ProtectedRoute from "./routes/ProtectedRoute";
import Chat from "./modules/Onboarding/Chat";
import Start from "./modules/Onboarding/Start";
import ReportList from "modules/Reports/ReportList";
import ReportView from "modules/Reports/ReportView";
import ReportOverview from "modules/Reports/ReportOverview";
import MatchingReports from "modules/Reports/MatchingReports";
import ReportSearch from "modules/Reports/ReportSearch";
import ReportLibrary from "modules/Reports/ReportLibrary";
import ScrollToTop from "component/common/ScrollToTop";
import SearchModule from "./modules/Search";
import AdminPanel from "./modules/Admin/AdminPanel";
import SettingsModule from "./modules/Settings";
import DashboardModule from "./modules/Dashboard";

function App() {
  return (
    <AuthProvider>
      <AiAssistantProvider>
      <Router>
        <ScrollToTop />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/onboarding" element={<Chat />} />
          <Route path="/start" element={<Start />} />
          <Route path="/register" element={<Navigate to="/login" replace />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard" element={<DashboardModule />} />
            <Route path="/news" element={<NewsList />} />
            <Route path="/news/matching-news" element={<MatchingNews />} />
            <Route path="/news/news-view/:id" element={<NewsView />} />
            <Route path="/charts/*" element={<ChartsModule />} />
            <Route path="/models/*" element={<ModelsModule />} />
            <Route path="/materials/search/*" element={<SearchModule />} />
            <Route path="/reports/search" element={<ReportSearch />} />
            {/* report module */}
            <Route path="/reports" element={<ReportList />} />
            <Route path="/reports/view/:id" element={<ReportView />} />
            <Route path="/reports/overview" element={<ReportOverview />} />
            <Route path="/reports/matching-reports" element={<MatchingReports />} />
            <Route path="/reports/library" element={<ReportLibrary />} />
            <Route path="/admin" element={<AdminPanel />} />
            <Route path="/settings" element={<SettingsModule />} />
          </Route>
          <Route path="*" element={<Login />} />
        </Routes>
        <AiAssistantPanel />
      </Router>
      </AiAssistantProvider>
    </AuthProvider>
  );
}

export default App;
